import contentTopHeader from "@/components/contentTopHeader";
import AuthService from "@/services/auth";
import { MyEvents } from "@/helper";
import UserTag from "@/components/user_tag";

export default {
  props: {
    name: String,
    replaceMenuWith: {
      type: Array,
      default: () => [],
    },
    tabActivePill: Boolean,
  },
  components: {
    contentTopHeader,
    UserTag,
  },
  data() {
    return {
      activeTab: "",
      daysFilter: 7,
      tabs: [
        {
          id: "dashboard",
          title: "Analytics",
          pathName: "Dashboard",
          // icon: require("../../../static/images/edit-curves.svg"),
        },
        // {
        //   id: "sales",
        //   title: "Sales",
        //   pathName: "Sell",
        //   // icon: require("../../../static/images/delivery.svg"),
        // },
        // {
        //   id: "payments",
        //   title: "Payments",
        //   pathName: "PaymentIndex",
        //   // icon: require("../../../static/images/credit-card.svg"),
        // },
        // {
        //   id: "top-creators",
        //   title: "Top Creators",
        //   pathName: "TopCreators",
        //   // icon: require("../../../static/images/settings-gear.svg"),
        // },
      ],
      dropdownMenu: [
        {
          id: "profile",
          title: "Profile",
          pathName: "UserProfile",
          icon: require("../../../static/images/file-copies.svg"),
        },
        {
          id: "settings",
          title: "Settings",
          pathName: "UserSettings",
          icon: require("../../../static/images/settings-gear.svg"),
        },
        {
          id: "signOut",
          title: "Sign Out",
          icon: require("../../../static/images/log-out.svg"),
        },
      ],
    };
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    isActiveTab(tab) {
      return this.name === tab;
    },
    isActiveInnerTab(tab) {
      return this.activeInnerTab === tab;
    },
    signOut() {
      AuthService.signout()
      this.$router.push({ path: '/' })
      this.$root.$emit(MyEvents.AUTH_SIGNOUT)
    },
    setTab(pathName) {
      this.$router.push({ name: pathName });
    },
    setMenuAction(menu) {
      switch (menu.id) {
        case "profile":
          this.$router.push(`/${this.currentUser.slug}`);
          break;
        case "signOut":
          this.signOut();
          break;
        default:
          this.$router.push({ name: menu.pathName });
          break;
      }
    },
    async isCreatorVerified() {
      if (AuthService.isAuthenticated()) {
        await AuthService.checkTokenValidation().then((response) => {
          if (response.body !== false) {
            AuthService.setUser(response.body)
          }
        })
      }
    },
  },

  async created() {
    await this.isCreatorVerified()

    this.activeTab = this.name;
    if (!(this.currentUser.user_type === "artist" || this.currentUser.user_type === 'brand')) {
      this.tabs = this.tabs.filter(tab => tab.id !== 'sales' && tab.id !== 'manage')
    }
    if (['artist', 'brand'].indexOf(this.currentUser.user_type) > -1 && this.currentUser.creator_verified !== true) {
      this.tabs = this.tabs.filter(tab => tab.id !== 'sales' && tab.id !== 'manage')
    }

    if (this.replaceMenuWith.length) {
      this.tabs = this.replaceMenuWith;
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboardnav/dashboardnav.ctrl.js